<template>
    <div>
        <v-container fluid class="grey lighten-3">
            <v-dialog v-model="reviewObj.showReviewDialog" persistent max-width="600" class="white">
                <add-review
                    :key="Math.floor(Math.random() * 10)"
                    :appointmentId="this.$route.params.appointmentId"
                    @review-added="reviewSent" 
                    @cancel="dismissReview"
                ></add-review>
            </v-dialog>
            <v-row style="min-height: calc(80vh - 64px)">                
                <v-col cols="12" sm="12" md="7" class="text-center pt-0">
                    <v-row>
                        <!-- <v-col cols="12" sm="12" class="hidden-md-and-up py-0">
                            <v-btn class="accent" @click="sheet = true">Show Appointment Details</v-btn>
                        </v-col> -->
                        <v-col cols="12" class="text-center" v-if="callDetailsLoading">
                            <v-progress-circular
                                    :size="50"
                                    :width="5"
                                    color="primary"
                                    indeterminate
                            ></v-progress-circular>

                            <h2 class="font-weight-regular mt-12">Initiating Call....</h2>
                        </v-col>

                        <v-col cols="12" sm="12" class="" v-show="!callDetailsLoading" v-if="!callEnded">
                            <v-card raised style="border-radius: 10px; overflow: hidden">
                                <div style="height: calc(100vh - 190px); width: 100%; " id="meet"></div>
                            </v-card>
                        </v-col>

                        <v-col cols="12" class="text-center" v-if="callEnded">
                            <h2 class="font-weight-regular mb-2">Thank You for choosing <b>HealthyAlways</b>.</h2>
                            <h3 class="font-weight-regular mb-3">Your Call has ended.</h3>
                            <v-btn class="accent" to="/">Go Back to Dashboard</v-btn>                            
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" sm="12" md="5" class="hidden-sm-and-down py-0">
                    <v-tabs
                            v-model="tab"
                            color="darkPrimary"
                            class="pt-2"
                            height="44px"
                    >
                        <v-tabs-slider></v-tabs-slider>
                        <v-tab style="font-size: 12px;" href="#appointment">
                            Appointment
                        </v-tab>
                        <v-tab style="font-size: 12px;" href="#medical">
                            Medical Records
                        </v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab">
                            <v-tabs-slider></v-tabs-slider>
                            <v-tab-item
                                value="appointment"
                            >
                                <appointment-details
                                    ref="appt"
                                    :appointmentDetailsProp="appointmentDetails"                                    
                                    :hideComplete="true"
                                    :hideVideoCall="true"
                                    :hideTicket="true"
                                    :key="appointmentDetails.id"                                                                
                                    :showActions="true"                                    
                                >
                                </appointment-details>
                            </v-tab-item>

                            <v-tab-item
                                value="medical"
                            >
                                <v-row class="hidden-sm-and-down">
                                    <v-col cols="12" sm="12">
                                        <v-card outlined>
                                            <v-card-text>
                                                <v-row class="pb-0" dense>
                                                    <v-col cols="12" sm="12" md="5" class="pb-0">
                                                        <v-select 
                                                        v-model="recordFilter" 
                                                        solo 
                                                        flat 
                                                        class="solo-bordered"
                                                        item-text="text"
                                                        item-value="value"
                                                        :items="recordFilters"></v-select>
                                                    </v-col>
                                                    <v-spacer></v-spacer>
                                                    <v-col cols="12" sm="12" md="5" class="pb-0 d-flex align-sm-end flex-column">
                                                    <v-btn rounded class="accent" style="margin-bottom: -20px" @click="addRecordDialog = true">
                                                            Add New Record
                                                            <v-icon right>mdi-arrow-right</v-icon>
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>


                                                <template >
                                                    <div class="d-flex justify-center" v-if="loadingMedicalRecords">
                                                        <v-progress-circular                                                                                                            
                                                        class="my-2"
                                                        :size="50"
                                                        :width="5"
                                                        color="darkPrimary"
                                                        indeterminate
                                                ></v-progress-circular>
                                                    </div>
                                                <v-simple-table v-else>
                                                    <template v-slot:default>
                                                        <thead>
                                                        <tr>
                                                            <th class="text-left">Date</th>
                                                            <th class="text-left">Type</th>
                                                            <th class="text-left">Upload Date</th>
                                                            <th class="text-left">Action</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        <tr v-for="medicalRecord in medicalRecordsList" :key="medicalRecord.id"
                                                            @click="showRecordDetails(medicalRecord)"
                                                            :class="{'grey lighten-3' : medicalRecordDetails === medicalRecord}"
                                                            class="pointer">
                                                            <td style="padding: 12px">
                                                                <v-avatar color="grey lighten-2" size="40" tile>
                                                                    <b>
                                                                        {{ dateutils.utcToLocal(medicalRecord.created_at).format('DD') }}
                                                                        <br>
                                                                        {{ dateutils.utcToLocal(medicalRecord.created_at).format('MMM') }}
                                                                    </b>
                                                                </v-avatar>
                                                            </td>
                                                            <td>
                                                                <v-chip>
                                                                    {{ medicalRecord.type }}
                                                                </v-chip>
                                                            </td>
                                                            <td>
                                                                {{ dateutils.utcToLocal(medicalRecord.created_at).format('dddd, D MMMM YYYY') }}
                                                            </td>
                                                            <td>
                                                                <v-btn small outlined color="darkPrimary" class="mr-2"
                                                                    @click="medicalRecordDetails = medicalRecord">
                                                                    View Record
                                                                </v-btn>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="!medicalRecordsList.length">
                                                            <td colspan="5" class="text-center">
                                                                <div class="text-center my-6">
                                                                    <v-icon large>mdi-alert</v-icon>
                                                                    <br>
                                                                    <h3 class="font-weight-regular">No Records Found</h3>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                                </template>
                                                
                                                <v-pagination
                                                        @input="getMedicalRecords"
                                                        v-model="page"
                                                        :length="medicalRecordsPaginationDetails.last_page"
                                                        v-if="medicalRecordsPaginationDetails.total > filters.limit"
                                                ></v-pagination>
                                            </v-card-text>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                    </v-tabs-items>
                    
                </v-col>
            </v-row>
        </v-container>
        <v-dialog v-model="leaveCallObj.showDialog" max-width="500px">
            <v-card>
                <v-card-title>
                    End Call
                </v-card-title>
                <v-card-text>
                    <template v-if="leaveCallObj.isEndCall">
                        Do you want to mark this appointment as complete?
                    </template>
                    <template v-else>
                        Do you want to end this call?
                    </template>
                    
                    <p v-if="leaveCallObj.show_mark_complete">
                        <v-checkbox v-model="leaveCallObj.mark_complete"
                        color="darkPrimary"
                        label="Mark this appointment as complete?"
                        ></v-checkbox>
                        
                    </p>
                    <v-card-actions>
                        <v-spacer></v-spacer>                        
                        <v-btn 
                            :disabled="leaveCallObj.mark_complete_loading" 
                            @click="leaveCallNegativeAction()" 
                            outlined 
                            color="darkPrimary"
                        >
                            No
                        </v-btn>
                        <v-btn 
                            @click="leaveCallPositiveAction()" 
                            outlined 
                            color="darkPrimary"
                            :disabled="leaveCallObj.mark_complete_loading"
                        :loading="leaveCallObj.mark_complete_loading"
                        >
                            Yes
                        </v-btn>
                    </v-card-actions>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="sheet" max-width="812px">
                    <medical-record-details v-on:refreshList="getMedicalRecords()" 
                        :key="medicalRecordDetails.id"
                        :medical-record-details-prop="medicalRecordDetails"
                        :show-actions="true">
                    </medical-record-details>
        </v-dialog>
        <v-dialog v-model="addRecordDialog" max-width="400" persistent>
            <v-card style="position: relative">
                <div style="position: absolute; top: 0; bottom: 0; left: 0; right: 0; background: white; z-index: 1; text-align: center"
                     v-if="uploadSucess">
                    <div style="position: absolute; top: 10%; right: 0; left: 0">
                        <v-icon color="green" style="font-size: 100px" class="mt-12">
                            mdi-checkbox-marked-circle-outline
                        </v-icon>

                        <h3 class="font-weight-regular my-5">Record Uploaded Successfully</h3>

                        <v-btn class="primary" @click="addRecordDialog = uploadSucess = false">Close</v-btn>
                    </div>
                </div>
                <v-card-title>
                    Add Record
                </v-card-title>
                <v-card-text class="pb-0">
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-form id="addMedicalRecord">
                                <v-row dense>
                                    <v-col cols="12" sm="12">
                                        <v-text-field 
                                        v-model="recordTitle"
                                        label="Name" type="text" name="name" outlined></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-select :items="recordTypes" v-model="recordType" name="type" outlined>

                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" sm="12" class="py-0">
                                        <v-checkbox 
                                            name="share_with"
                                            :value="appointmentDetails.doctor.id"
                                            v-model="shareWith"
                                            :label="`Share With ${appointmentDetails.doctor.salutation} ${appointmentDetails.doctor.name}`"
                                        ></v-checkbox>                                        
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <input type="file" multiple id="attachments"/>
                                    </v-col>
                                    
                                </v-row>
                            </v-form>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn text @click.prevent="addRecordDialog = false" class="mr-3">
                        Close
                    </v-btn>
                    <v-btn color="accent" @click.prevent="uploadRecord" :loading="saveLoading" :disabled="saveLoading">
                        Upload
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    var api;
    import {mapGetters} from 'vuex'
    import MedicalRecordDetails from "../components/MedicalRecordDetails";
    import AppointmentUtils from '../AppointmentUtils.js';
    import AddReview from "@/components/AddReview";
    import AppointmentDetails from "../components/AppointmentDetails";
    import * as compressor from "../FileCompress";

    export default {
        computed: {
            ...mapGetters([
                'userInfo',
                'firebaseNotification'
            ])
        },
        components: {
            AddReview,
            AppointmentDetails,
            MedicalRecordDetails
        },
        methods: {
            goToDashBoard(){
                this.$router.push({name: 'myAppointments'})                
            },
            showLeaveCallDialogMethod(isEndCall){
                if(isEndCall)
                    this.leaveCallObj.isEndCall = true
                else
                    this.leaveCallObj.isEndCall = false

                var appointmentUtils = new AppointmentUtils(this.appointmentDetails)                

                this.leaveCallObj.show_mark_complete = appointmentUtils.canMarkAsComplete()      
                if(this.leaveCallObj.isEndCall){
                    if(appointmentUtils.canMarkAsComplete())
                        this.leaveCallObj.showDialog = true
                }                
                else
                    this.leaveCallObj.showDialog = true
            },
            leaveCallPositiveAction(){
                
                if(this.leaveCallObj.mark_complete) {
                    this.markAsComplete()
                }
                else{
                    this.leaveCallObj.showDialog = false
                    this.callEnded = true
                    window.onbeforeunload = null;
                    this.goToDashBoard()
                }
                    
            },
            leaveCallNegativeAction(){
                if(this.leaveCallObj.isEndCall) {                    
                    this.leaveCallObj.showDialog = false
                    this.callEnded = true
                    window.onbeforeunload = null;
                    this.goToDashBoard()
                }
                else{
                    this.leaveCallObj.showDialog = false
                }                
            },
           
            markAsComplete() {
                this.leaveCallObj.mark_complete_loading = true
                this.axios.get(`${process.env.VUE_APP_API_URL}/api/appointments/`+this.$route.params.appointmentId+`/complete`)
                    .then((response) => {
                        if(response.data.status == 1){
                            this.callEnded = true
                            this.getAppointmentDetails();
                            this.showReview()

                        }
                        else if (response.data.status == 2) {                                                        
                            this.getAppointmentDetails();
                            this.$store.commit('showSnackbar', {message: response.data.message, color: ''})
                        }                                                
                        
                    })
                    .catch((e) => {
                        console.log(e)
                    })
                    .finally(() => {
                        this.leaveCallObj.mark_complete_loading = false   
                        this.leaveCallObj.showDialog = false                     
                    })
            },
            startCall() {
                this.callDetailsLoading = true
                var ctx = this
                return new Promise((resolve) => {
                    this.axios.get(`${process.env.VUE_APP_API_URL}/api/appointments/token/${ctx.appointmentId}`)
                    .then((response) => {
                        if(response.data.status == 2){
                            this.$store.commit('showSnackbar', {message: response.data.message})
                            this.$router.replace({name: 'myAppointments',params:{appointmentId:this.$route.params.appointmentId}})
                        }
                        else{
                            ctx.jwtToken = response.data.data
                            ctx.initiateVideoCall()
                        }
                        
                    })
                    .catch((error) => {
                        console.log(error)
                    })
                    .finally(() => {
                        ctx.callDetailsLoading = false
                        resolve()
                    })
                })
                
            },
            getAppointmentDetails() {
                this.axios.get(`${process.env.VUE_APP_API_URL}/api/appointments/${this.appointmentId}`)
                    .then((response) => {
                        this.appointmentDetails = null
                        this.appointmentDetails = response.data.data
                        this.shareWith = this.appointmentDetails.doctor.id
                    })
                    .catch((error) => {
                        console.log(error)
                    })
                    .finally(() => {
                        
                    })
            },
            getAppointmentDetailsAndShowMarkAsComplete(isEndCallPressed) {
                this.axios.get(`${process.env.VUE_APP_API_URL}/api/appointments/${this.appointmentId}`)
                    .then((response) => {
                        this.appointmentDetails = response.data.data
                        this.shareWith = this.appointmentDetails.doctor.id                                                
                                                        
                        this.showLeaveCallDialogMethod(isEndCallPressed)                

                    })
                    .catch((error) => {
                        console.log(error)
                    })
                    .finally(() => {
                        
                    })
            },
            endCall() {
                this.callEndTime = this.moment().format('HH:mm')
                this.callEnded = true
            },
            initiateVideoCall() {
                this.callEndTime = ""
                this.callEnded = false
                const domain = this.callServerEndpoint
                

                const options = {
                    roomName: this.appointmentId,
                    jwt: this.jwtToken,
                    parentNode: document.getElementById('meet'),
                };
                try{
                    api.dispose()
                    const myNode = document.getElementById("meet") 
                    myNode.innerHTML = '';
                }
                catch(e){
                    console.log(e)
                }
                // eslint-disable-next-line no-undef                
                api = new JitsiMeetExternalAPI(domain, options);
                // api.on('videoConferenceLeft',()=>{
                    
                // })
                
                api.on('readyToClose', () => {
                    this.endCall()
                    this.getAppointmentDetailsAndShowMarkAsComplete(true)
                    
                    
                });
            },
            importCallScript() {
                return new Promise((resolve) => {
                    let scriptExists = document.head.contains(document.getElementById('call-script'));
                    if (!scriptExists) {
                        let jitsiApiScript = document.createElement('script')
                        jitsiApiScript.setAttribute('id', 'call-script')
                        jitsiApiScript.setAttribute('src', `https://${this.callServerEndpoint}/external_api.js`)
                        document.head.appendChild(jitsiApiScript)
                        jitsiApiScript.addEventListener('load', () => {
                            resolve()
                        })
                    } else {
                        resolve()
                    }
                })
            },
            showReview(){
                this.reviewObj.showReviewDialog = true
            },
            reviewSent(){
                window.onbeforeunload = null;
                this.goToDashBoard()
            },
            dismissReview(){
                this.reviewObj.showReviewDialog = false
            },
            async uploadRecord() {
                
                var multipleFiles = document.getElementById('attachments').files                
                var compressedFiles = await compressor.compressMultipleFiles(multipleFiles)
                if(!compressor.validateFileSizes(compressedFiles)){
                    this.$store.commit('showSnackbar', {message:"File too large"})
                    return;                    
                }
                this.saveLoading = true
                let form = document.getElementById("addMedicalRecord")
                let formData = new FormData(form)
                formData.set('attachments[]',null)
                compressedFiles.forEach((input) => {
                    formData.append('attachments[]',input)
                })

                this.axios.post(`${process.env.VUE_APP_API_URL}/api/patients/${this.userInfo.id}/medical-records`, formData)
                    .then((response) => {
                        if (response.data.status === 1) {
                            this.uploadSucess = 1;
                            this.getMedicalRecords();
                            form.reset();
                            document.getElementsByClassName("v-file-input__text")[0].innerHTML = "";
                        }
                    })
                    .catch(() => {

                    })
                    .finally(() => {
                        this.saveLoading = false
                    })
            },
            getMedicalRecords: function () {
                if (!this.userInfo) {
                    return;
                }
                this.loadingMedicalRecords = true;
                this.filters.page = this.page;
                this.filters.record_type = this.recordFilter
                this.axios.get(`${process.env.VUE_APP_API_URL}/api/patients/${this.userInfo.id}/medical-records`, {
                    params: this.filters
                }).then((response) => {
                    if (response.data.status === 1) {
                        this.medicalRecordsPaginationDetails = response.data.data;
                        this.medicalRecordsList = this.medicalRecordsPaginationDetails.data;

                        if (this.medicalRecordsList.length) {
                            this.medicalRecordDetails = this.medicalRecordsList[0];
                        }
                    }
                    this.loadingMedicalRecords = false;
                }).catch((error) => {
                    console.log(error);
                    this.loadingMedicalRecords = false;
                });
            },
            showRecordDetails:function(record){
                this.medicalRecordDetails = record;
                this.sheet = true;
            },
            releaseResources(){
                try{
                    api.dispose()
                    window.onbeforeunload = null
                }catch(e){
                    console.log(e)
                }
            }
            
        },
        data() {
            return {
                sheet: false,
                callEnded: false,
                callEndTime: '',
                jwtToken: '',
                callDetailsLoading: '',
                callServerEndpoint: '',
                appointmentId: null,
                appointmentDetails: {
                  doctor: {
                  }
                },
                addRecordDialog: false,
                uploadSucess: false,
                saveLoading: false,
                uploadFileName:null,
                recordTitle:"",
                recordType: 'Prescription',
                recordTypes: ['Prescription', 'Medical Report'],
                shareWith: "",
                filters: {
                    format_type: 'paginate',
                    limit: 6
                },
                medicalRecordsPaginationDetails: {},
                page: 1,
                loadingMedicalRecords: false,
                medicalRecordsList: [],
                recordFilter: '',
                recordFilters: [
                    {
                        text:'All Records',
                        value:'',
                    },
                    {
                        text:'Prescription',
                        value:'Prescription',
                    },
                    {
                        text:'Medical Report',
                        value:'Medical Report',
                    }                
                ],
                medicalRecordDetails: {},
                leaveCallObj:{
                    isEndCall:false,
                    showDialog:false,
                    show_mark_complete:false,
                    mark_complete:false,
                    mark_complete_loading:false
                },
                reviewObj:{
                    showReviewDialog:false                
                },
                tab:""
               
            }
        },
        watch:{
            addRecordDialog(){
                
                this.recordTitle = ""
                this.uploadFileName=null
                document.getElementById("addMedicalRecord").reset();
            },
            recordFilter(){
                this.getMedicalRecords()
            },
            firebaseNotification() {
                console.log("UPDATEI VIEO CALL")
                this.getMedicalRecords()
                this.getAppointmentDetails()
                this.$refs.appt.getAppointmentDetails()
            }
        },
        beforeDestroy(){
            console.log("BEFORE DESTROY")
            this.releaseResources()
        },
        mounted() {
            let inputs = document.querySelectorAll('.v-file-input input');
            [...inputs].forEach((input) => {
                input.remove()
            })
            
            
            this.appointmentId = this.$route.params.appointmentId;
            var ctx = this
            window.onbeforeunload = function (e) {

                if(!this.callEnded)
                    ctx.getAppointmentDetailsAndShowMarkAsComplete(false)
                e = e || window.event;
                
                var text = 'Mark appointment status';
                if(this.callEnded)
                    text = "";
                if (e) {
                    e.returnValue = text
                }
                
                return text
            };
            window.onunload = function(){
                this.releaseResources()                
            }                                    
            
            this.callServerEndpoint = process.env.VUE_APP_CALL_SERVER_DOMAIN
            this.importCallScript()
                .then(() => {
                    this.startCall().then(()=>{
                        this.getAppointmentDetails();
                        this.getMedicalRecords();
                    })
                });
            
            
            document.addEventListener("visibilitychange", function(){          
                console.log("VISCHANGE");
                if(!document.hidden)
                    ctx.getMedicalRecords()
            }, false);
        }
    }
</script>

<style scoped>
</style>
